import i18n from 'services/i18n';
import { convertToStartCase, isFunction } from 'utilities/global';
import { EN_US } from 'consts';

export const getFieldTranslation = ({ fieldsType, ...rest }) => {
  return fieldsType === 'payment'
    ? getPaymentFieldsTranslation(rest)
    : getPayoutFieldTranslation(rest);
};
const getPaymentFieldsTranslation = ({
  methodType,
  fieldLocation,
  fieldName,
  fallback
}) => {
  const translatedLabel = getTranslationWithFallback({
    key: `${methodType}_${
      fieldLocation === 'fields' ? fieldLocation : 'options'
    }_${fieldName}_name`,
    fallback,
    prefix: 'fields'
  });
  return translatedLabel;
};
const getPayoutFieldTranslation = ({ fieldName, fallback }) => {
  const fallbackFunc = () =>
    getTranslationWithFallback({
      key: `payout.fields.${fieldName}_name`,
      fallback,
      prefix: 'fields'
    });
  const translatedLabel = getTranslationWithFallback({
    key: `payout.${fieldName}_name`,
    fallback: fallbackFunc,
    prefix: 'fields'
  });

  return translatedLabel;
};

export const getPmtTranslation = ({ key, fallback }) => {
  const translatedLabel = getTranslationWithFallback({
    key,
    fallback,
    prefix: 'fields',
    meta: {
      useFallback: shouldUseFallback(),
      useCurrentLanguageAsFallback: true
    }
  });
  return translatedLabel;
};

export const getTranslationWithFallback = ({
  key,
  fallback,
  prefix,
  meta = { useFallback: false, useCurrentLanguageAsFallback: false }
}) => {
  const getFallbackValue = () =>
    isFunction(fallback) ? fallback() : convertToStartCase(fallback);
  const { useFallback, useCurrentLanguageAsFallback } = meta || {};

  if (useFallback) {
    return getFallbackValue();
  }

  const translationKey = `${prefix ? `${prefix}:` : ''}${key}`;
  // we need to override fallback language, because if it will not find a key in a specific lang file
  // - it will look for him in the default file(english)
  const isTranslationExists = i18n.exists(translationKey, {
    fallbackLng: useCurrentLanguageAsFallback ? i18n.language : ''
  });

  if (isTranslationExists) {
    const translation = i18n.t(translationKey);
    return translation;
  }

  return getFallbackValue();
};

const shouldUseFallback = () => i18n.language === EN_US;
